module.exports = __webpack_public_path__ + "img/banner_left.aea1f807.png";